import {
  GameplayLogsLogsClient,
  GameplayLogRequest,
  GameplayLog,
} from "@nestcoinco/hyper-api-gateway-api-client";

import apiConfig from "../config/api-config";
import { axiosInstance } from "../config/axios-instance";

const gameplayLogsClient = new GameplayLogsLogsClient(
  apiConfig,
  undefined,
  axiosInstance
);

interface LogGameplayEventParams {
  entryId: string;
  gameplayLogRequest: GameplayLogRequest;
}

const handleLogGameplayEvent = async ({
  entryId,
  gameplayLogRequest,
}: LogGameplayEventParams): Promise<GameplayLog> => {
  return (await gameplayLogsClient.logEvent(entryId, gameplayLogRequest)).data;
};

export { handleLogGameplayEvent, LogGameplayEventParams };
